module.exports = __webpack_public_path__ + "img/paraswap.4dc8e369.png";